
import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';

import Modal, { ModalHeader } from '@vromo/ui/components/Modal';
import { useToasts } from '@vromo/ui/components/Toasts';
import { Platform } from '@vromo/models';
import OverlayablePanel from '@vromo/ui/components/Overlay';
import Title from '@vromo/ui/components/Title';
import { useIntegrationsActions, useIntegrationsNav, useIntegrationsPage } from '../../hooks';
import { firstLetterCap } from '@vromo/ui';
import { SquareConfigure } from './squareConfigure';
import { UberEatsKHConfigure } from './uberEatsConfigure';









/** modal to created / add a new integration */
export const IntegrationConfigure = observer(() => {

    const { cancelIntegrationConfig } = useIntegrationsActions()
    const { isLoading, fetched, allPosibleIntegrations } = useIntegrationsPage()
    const { modalOpen, goToWindow } = useIntegrationsNav({ modalOpened: true })
    const showToast = useToasts();
    const { platform } = useParams<{ platform: Platform }>()



    const IntegrationConfiguration = useMemo(() => {

        if (platform.includes("square"))
            return SquareConfigure

        else if (platform.includes("uber-eats"))
            return UberEatsKHConfigure
        else
            throw new Error("Not implemented")

    }, [allPosibleIntegrations, platform])



    useEffect(function returnIfPlatformNotCompatible() {
        if (!allPosibleIntegrations.includes(platform)) {
            showToast(`${platform} integration is not configurable`, 'warning')
            goToWindow("list")
        }
    }, [platform, goToWindow, allPosibleIntegrations])



    return (
        <Modal
            isOpen={modalOpen}
            showCloseButton={!isLoading}
            onRequestClose={() => cancelIntegrationConfig({
                iframe: false,
                platform,
                skipConfirm: false,
            })}
        >
            <OverlayablePanel active={isLoading} loadingText='Loading'>
                <div>
                    <ModalHeader css={firstLetterCap}>
                        <Title>{platform} integration configuration</Title>
                    </ModalHeader>
                    <IntegrationConfiguration />
                </div>
            </OverlayablePanel>
        </Modal >
    );
});




